import { takeLatest, put, all, call } from 'redux-saga/effects';
import parameterActionTypes from './parameterActionTypes';
import {
  getParameterFailed,
  getParameterSuccess,
  getParameterSetsFailed,
  getParameterSetsSuccess,
  saveProductParameterValueSuccess,
  saveProductParameterValueFailed,
  saveParameterSetFailed,
  saveParameterSetSuccess,
  deleteProductParameterFailed,
  deleteProductParameterSuccess,
  deleteParameterSetFailed,
  deleteParameterSetSuccess,
} from './parameterActions';
import Server from '../../service/Server';

export function* fetchParameters({ payload: { baseUrl, keys } }) {
  try {
    const parameters = yield call(Server.getProductParameters, baseUrl, keys);
    if (parameters.err) {
      yield put(getParameterFailed(parameters.err));
    } else {
      yield put(getParameterSuccess(parameters));
    }
  } catch (error) {
    yield put(getParameterFailed(error));
  }
}

export function* onFetchParameterStart() {
  yield takeLatest(parameterActionTypes.GET_PARAMETERS_START, fetchParameters);
}

export function* fetchParameterSet({ payload: { baseUrl, keys } }) {
  try {
    const parameterSet = yield call(Server.getParameterSet, baseUrl, keys);
    if (parameterSet.err) {
      yield put(parameterSet.err);
    } else {
      yield put(getParameterSetsSuccess(parameterSet));
    }
  } catch (error) {
    yield put(getParameterSetsFailed(error));
  }
}

export function* onFetchParameterSetStart() {
  yield takeLatest(
    parameterActionTypes.GET_PARAMETERS_SET_START,
    fetchParameterSet
  );
}

export function* saveProductParameter({ payload }) {
  try {
    if (payload.id) {
      const parameterValue = yield call(
        Server.updateProductParameters,
        payload.id,
        payload.name
      );
      if (parameterValue.err) {
        yield put(saveProductParameterValueFailed(parameterValue.err));
      } else {
        yield put(saveProductParameterValueSuccess(parameterValue.data));
      }
    } else {
      const parameterValue = yield call(Server.saveProductParameter, payload);
      if (parameterValue.err) {
        yield put(saveProductParameterValueFailed(parameterValue.err));
      } else {
        yield put(saveProductParameterValueSuccess(parameterValue.data));
      }
    }
  } catch (error) {
    yield put(saveProductParameterValueFailed(error));
  }
}

export function* deleteProductParameter({ payload }) {
  try {
    const deletedId = yield call(Server.deleteProductParameter, payload);
    if (deletedId.err) {
      yield put(deleteProductParameterFailed(deletedId.err));
    } else {
      yield put(deleteProductParameterSuccess(deletedId.data));
    }
  } catch (error) {
    yield put(deleteProductParameterFailed(error));
  }
}

export function* onDeleteProductParameterSuccess() {
  yield takeLatest(
    parameterActionTypes.DELETE_PARAMETER_VALUE_SUCCESS,
    fetchParameters
  );
}

export function* onDeleteProductParameterStart() {
  yield takeLatest(
    parameterActionTypes.DELETE_PARAMETER_VALUE_START,
    deleteProductParameter
  );
}

export function* onSaveParameterValueStart() {
  yield takeLatest(
    parameterActionTypes.SAVE_PARAMETER_START,
    saveProductParameter
  );
}

export function* onProductParameterValueSavedGetSet() {
  yield takeLatest(
    parameterActionTypes.SAVE_PARAMETER_VALUE_SUCCESS,
    fetchParameterSet
  );
}

export function* onProductParameterValueSavedGetParameters() {
  yield takeLatest(
    parameterActionTypes.SAVE_PARAMETER_VALUE_SUCCESS,
    fetchParameters
  );
}

export function* saveParameterSet({ payload }) {
  try {
    if (payload.id) {
      const parameterSet = yield call(
        Server.updateParameterSet,
        payload.id,
        payload.name
      );
      if (parameterSet.err) {
        yield put(saveParameterSetFailed(parameterSet.err));
      } else {
        yield put(saveParameterSetSuccess());
      }
    } else {
      const parameterSet = yield call(Server.saveParameterSet, payload);
      if (parameterSet.err) {
        yield put(saveParameterSetFailed(parameterSet.err));
      } else {
        yield put(saveParameterSetSuccess());
      }
    }
  } catch (error) {
    yield put(saveParameterSetFailed(error));
  }
}

export function* onSaveParameterSetStart() {
  yield takeLatest(
    parameterActionTypes.SAVE_PARAMETER_SET_START,
    saveParameterSet
  );
}

export function* onSaveParameterSetSuccess() {
  yield takeLatest(
    parameterActionTypes.SAVE_PARAMETER_SET_SUCCESS,
    fetchParameterSet
    //fetchParameters
  );
}

export function* deleteParameterSet({ payload }) {
  try {
    const deletedId = yield call(Server.deleteParameterSet, payload);
    if (deletedId.err) {
      yield put(deleteParameterSetFailed(deletedId.err));
    } else {
      yield put(deleteParameterSetSuccess(deletedId.data));
    }
  } catch (error) {
    yield put(deleteParameterSetFailed(error));
  }
}

export function* onDeleteParameterSetSuccess() {
  yield takeLatest(
    parameterActionTypes.DELETE_PARAMETER_SET_SUCCESS,
    fetchParameterSet
  );
}

export function* onDeleteParameterSetStart() {
  yield takeLatest(
    parameterActionTypes.DELETE_PARAMETER_SET_START,
    deleteParameterSet
  );
}

export function* getParameterOptions({ payload: { id, baseUrl, keys } }) {
  try {
    yield put({
      type: parameterActionTypes.GET_PARAMETER_OPTIONS_START,
    });
    const parameterOptions = yield call(
      Server.getProductParameterOption,
      id,
      baseUrl,
      keys
    );
    if (parameterOptions.err) {
      yield put({
        type: parameterActionTypes.GET_PARAMETER_OPTIONS_FAILED,
        payload: parameterOptions.err,
      });
    } else {
      yield put({
        type: parameterActionTypes.GET_PARAMETER_OPTIONS_SUCCESS,
        payload: parameterOptions,
      });
    }
  } catch (error) {
    yield put({
      type: parameterActionTypes.GET_PARAMETER_OPTIONS_FAILED,
      payload: error,
    });
  }
}

export function* onSaveParameterOptionsSuccess() {
  yield takeLatest(
    parameterActionTypes.SAVE_PARAMETER_OPTION_SUCCESS,
    getParameterOptions
  );
}

export function* parameterSagas() {
  yield all([
    call(onFetchParameterSetStart),
    call(onFetchParameterStart),
    call(onSaveParameterValueStart),
    call(onProductParameterValueSavedGetParameters),
    call(onProductParameterValueSavedGetSet),
    call(onSaveParameterSetStart),
    call(onSaveParameterSetSuccess),
    call(onDeleteProductParameterStart),
    call(onDeleteProductParameterSuccess),
    call(onDeleteParameterSetStart),
    call(onDeleteParameterSetSuccess),
    call(onSaveParameterOptionsSuccess),
  ]);
}
